const REFERRAL_REQUEST_TTL = 21; // days
const MAX_REFERRAL_REQUESTS_PER_PERIOD = 1;
const MEMBER_MAX_REFERRAL_REQUESTS_PER_PERIOD = 99;
const MAX_REFERRALS_PER_PERIOD = 10;

// The referral marketplace is segmented into per-country markets so that
// candidates are only matched with referrers from the same market. Countries
// without a dedicated market share the default (US) marketplace, which also
// holds all activity from before markets existed.
const DEFAULT_REFERRAL_MARKET = 'US';
const DEDICATED_REFERRAL_MARKETS = ['IN'];

// user.data.country is set from IP geo at login; normalize before comparing so
// a lowercase code can't quietly fall through to the default market.
const normalizeCountry = (countryCode) => countryCode?.toUpperCase();

const getReferralMarket = (countryCode) => (
  DEDICATED_REFERRAL_MARKETS.includes(normalizeCountry(countryCode))
    ? normalizeCountry(countryCode)
    : DEFAULT_REFERRAL_MARKET
);

// Countries whose candidates may submit referral requests. Deliberately wider
// than the market list above: CA candidates are eligible but share the US pool,
// since only countries in DEDICATED_REFERRAL_MARKETS get their own marketplace.
const REFERRAL_ELIGIBLE_COUNTRIES = ['US', 'CA', 'IN'];

const isReferralEligibleCountry = (countryCode) => (
  REFERRAL_ELIGIBLE_COUNTRIES.includes(normalizeCountry(countryCode))
);

module.exports = {
  REFERRAL_REQUEST_TTL,
  MAX_REFERRAL_REQUESTS_PER_PERIOD,
  MEMBER_MAX_REFERRAL_REQUESTS_PER_PERIOD,
  MAX_REFERRALS_PER_PERIOD,
  DEFAULT_REFERRAL_MARKET,
  DEDICATED_REFERRAL_MARKETS,
  REFERRAL_ELIGIBLE_COUNTRIES,
  getReferralMarket,
  isReferralEligibleCountry,
};
